<template>
    <div id="Compare" class="starter-template">
        <b-container>
            <br>
            <b-row class="border border-primary itsBkg" align-v="center">
                <b-col cols="6">
                    <b-row align-v="center">
                        <b-col>
                            <b-link :href="outingUrlL"><h5>{{ outingNameL }}</h5></b-link>
                        </b-col>
                        <b-col v-if="oL.companyUrl">
                            <b-link :href="oL.companyUrl" target="_blank"><h5>{{ oL.companyName }}</h5></b-link>
                        </b-col>
                        <b-col v-else>
                            <h5>{{ oL.companyName }}</h5>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col cols="6">
                    <b-row align-v="center">
                        <b-col>
                            <b-link :href="outingUrlR"><h5>{{ outingNameR }}</h5></b-link>
                        </b-col>
                        <b-col v-if="oR.companyUrl">
                            <b-link :href="oR.companyUrl" target="_blank"><h5>{{ oR.companyName }}</h5></b-link>
                        </b-col>
                        <b-col v-else>
                            <h5>{{ oR.companyName }}</h5>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <b-row v-if="toBarL || toBarR" class="mt-2 border border-primary itsBkg">
                <b-col class="m-1" v-if="toBarL">
                    <b-row v-if="$mq === 'lg' || $mq === 'xl'">
                        <b-col cols="2" class="m-1">
                            <h5>{{$t('WHERE_TO', resLoc)}}:</h5>
                        </b-col>
                        <b-col class="m-1">
                            <span v-html="toBarL"></span>
                        </b-col>
                    </b-row>
                    <div v-else>
                            <h5>{{$t('WHERE_TO', resLoc)}}:</h5>
                            <span v-html="toBarL"></span>
                    </div>
                </b-col>
                <b-col v-else></b-col>
                <b-col class="m-1" v-if="toBarR">
                    <b-row v-if="$mq === 'lg' || $mq === 'xl'">
                        <b-col cols="2" class="m-1">
                            <h5>{{$t('WHERE_TO', resLoc)}}:</h5>
                        </b-col>
                        <b-col class="m-1">
                            <span v-html="toBarR"></span>
                        </b-col>
                    </b-row>
                    <div v-else>
                        <h5>{{$t('WHERE_TO', resLoc)}}:</h5>
                        <span v-html="toBarR"></span>
                    </div>
                </b-col>
                <b-col v-else></b-col>
            </b-row>

            <b-row v-if="fromBarL || fromBarR" class="mt-2 border border-primary itsBkg">
                <b-col class="m-1" v-if="fromBarL">
                    <b-row v-if="$mq === 'lg' || $mq === 'xl'">
                        <b-col cols="2" class="m-1">
                            <h5>{{$t('WHERE_FROM', resLoc)}}:&nbsp;</h5>
                        </b-col>
                        <b-col class="m-1">
                            <span v-html="fromBarL"></span>
                        </b-col>
                    </b-row>
                    <div v-else>
                        <h5>{{$t('WHERE_FROM', resLoc)}}:&nbsp;</h5>
                        <span v-html="fromBarL"></span>
                    </div>
                </b-col>
                <b-col v-else></b-col>
                <b-col class="m-1" v-if="fromBarR">
                    <b-row v-if="$mq === 'lg' || $mq === 'xl'">
                        <b-col cols="2" class="m-1">
                            <h5>{{$t('WHERE_FROM', resLoc)}}:&nbsp;</h5>
                        </b-col>
                        <b-col class="m-1">
                            <span v-html="fromBarR"></span>
                        </b-col>
                    </b-row>
                    <div v-else>
                        <h5>{{$t('WHERE_FROM', resLoc)}}:</h5>
                        <span v-html="fromBarR"></span>
                    </div>
                </b-col>
                <b-col v-else></b-col>
            </b-row>

            <b-row v-if="outingWayTypeL || outingWayTypeR" class="mt-2 border border-primary itsBkg">
                <b-col class="m-2" v-if="outingWayTypeL">
                    <b-row v-if="$mq === 'lg' || $mq === 'xl'">
                        <b-col cols="2">
                            <h5>{{$t('TYPE', resLoc)}}:</h5>
                        </b-col>
                        <b-col>
                            <span v-html="outingWayTypeL"></span>
                        </b-col>
                    </b-row>
                    <div v-else>
                        <h5>{{$t('TYPE', resLoc)}}:</h5>
                        <span v-html="outingWayTypeL"></span>
                    </div>
                </b-col>
                <b-col v-else></b-col>
                <b-col class="m-2" v-if="outingWayTypeR">
                    <b-row v-if="$mq === 'lg' || $mq === 'xl'">
                        <b-col cols="2">
                            <h5>{{$t('TYPE', resLoc)}}:</h5>
                        </b-col>
                        <b-col>
                            <span v-html="outingWayTypeR"></span>
                        </b-col>
                    </b-row>
                    <div v-else>
                        <h5>{{$t('TYPE', resLoc)}}:</h5>
                        <span v-html="outingWayTypeR"></span>
                    </div>
                </b-col>
                <b-col v-else></b-col>
            </b-row>

            <b-row v-if="outingSubjTypeL || outingSubjTypeR" class="mt-2 border border-primary itsBkg">
                <b-col class="m-1" v-if="outingSubjTypeL">
                    <span v-html="outingSubjTypeL"></span>
                </b-col>
                <b-col v-else></b-col>
                <b-col class="m-2" v-if="outingSubjTypeR">
                    <span v-html="outingSubjTypeR"></span>
                </b-col>
                <b-col v-else></b-col>
            </b-row>

            <b-row v-if="individL || individR || unaidedL || unaidedR" class="mt-2 border border-primary itsBkg">
                <b-col class="m-1" v-if="individL || unaidedL">
                    <span v-html="individL">&nbsp;</span><span v-html="unaidedL"></span>
                </b-col>
                <b-col v-else></b-col>
                <b-col class="m-2" v-if="individR || unaidedR">
                    <span v-html="individR"></span>&nbsp;<span v-html="unaidedR"></span>
                </b-col>
                <b-col v-else></b-col>
            </b-row>


            <b-row v-if="oL.duratD!='0' || oL.duratH!='0' || oL.duratM!='0' || oR.duratD!='0' || oR.duratH!='0' || oR.duratM!='0'" class="mt-2 border border-primary itsBkg">
                <b-col class="m-2" v-if="oL.duratD!='0' || oL.duratH!='0' || oL.duratM!='0'">
                    <b-row v-if="$mq === 'lg' || $mq === 'xl'">
                        <b-col cols="2">
                            <h5>{{$t('TIME', resLoc)}}:</h5>
                        </b-col>
                        <b-col>
                            <span v-if="oL.duratD!=0">{{$t('DAYS',resLoc)}} {{oL.duratD}}<br></span>
                            <span v-if="oL.duratH!=0">{{$t('HOURS',resLoc)}} {{oL.duratH}}<br></span>
                            <span v-if="oL.duratM!=0">{{$t('MINUTES',resLoc)}} {{oL.duratM}}</span>
                        </b-col>
                    </b-row>
                    <div v-else>
                        <h5>{{$t('TIME', resLoc)}}:</h5>
                        <span v-if="oL.duratD!=0">{{$t('DAYS',resLoc)}} {{oL.duratD}}<br></span>
                        <span v-if="oL.duratH!=0">{{$t('HOURS',resLoc)}} {{oL.duratH}}<br></span>
                        <span v-if="oL.duratM!=0">{{$t('MINUTES',resLoc)}} {{oL.duratM}}</span>
                    </div>
                </b-col>
                <b-col v-else></b-col>
                <b-col class="m-2" v-if="oR.duratD!='0' || oR.duratH!='0' || oR.duratM!='0'">
                    <b-row v-if="$mq === 'lg' || $mq === 'xl'">
                        <b-col cols="2">
                            <h5>{{$t('TIME', resLoc)}}:</h5>
                        </b-col>
                        <b-col>
                            <span v-if="oR.duratD!=0">{{$t('DAYS',resLoc)}} {{oR.duratD}}<br></span>
                            <span v-if="oR.duratH!=0">{{$t('HOURS',resLoc)}} {{oR.duratH}}<br></span>
                            <span v-if="oR.duratM!=0">{{$t('MINUTES',resLoc)}} {{oR.duratM}}</span>
                        </b-col>
                    </b-row>
                    <div v-else>
                        <h5>{{$t('TIME', resLoc)}}:</h5>
                        <span v-if="oR.duratD!=0">{{$t('DAYS',resLoc)}} {{oR.duratD}}<br></span>
                        <span v-if="oR.duratH!=0">{{$t('HOURS',resLoc)}} {{oR.duratH}}<br></span>
                        <span v-if="oR.duratM!=0">{{$t('MINUTES',resLoc)}} {{oR.duratM}}</span>
                    </div>
                </b-col>
                <b-col v-else></b-col>
            </b-row>

            <b-row v-if="oL.price || oL.maxPrice || oR.price || oR.maxPrice" class="mt-2 border border-primary itsBkg">
                <b-col class="m-2" v-if="oL.price || oL.maxPrice">
                    <span v-if="oL.price && oL.maxPrice" class="m-2">
                        <h5>{{$t('PRICE', resLoc)}}:</h5>
                        {{$t('FROM', resLoc)}} {{ oL.price }}
                        <span v-html="oL.currency"></span>
                        {{$t('TO', resLoc)}} {{ oL.maxPrice }}
                    </span>
                    <span v-else class="m-2">
                        <span v-if="oL.forAll">
                            <h5>{{$t('PRICE', resLoc)}}:</h5>
                            <span v-if="oL.price">{{ oL.price }}</span>
                            <span v-else>{{ oL.maxPrice }}</span>
                        </span>
                        <span v-else>
                            <h5>{{$t('PRICE_F', resLoc)}}:</h5>
                            <span v-if="oL.price">{{ oL.price }}</span>
                            <span v-else>{{ oL.maxPrice }}</span>
                        </span>
                    </span>
                    <span v-html="oL.currency"></span>
                    <span v-if="oL.forAll"> {{$t('PRICE_A',resLoc)}}</span>
                    <span v-else> {{$t('PRICE_I',resLoc)}}</span>
                </b-col>
                <b-col v-else></b-col>

                <b-col class="m-2" v-if="oR.price || oR.maxPrice">
                    <span v-if="oR.price && oR.maxPrice" class="m-2">
                        <h5>{{$t('PRICE', resLoc)}}:</h5>
                        {{$t('FROM', resLoc)}} {{ oR.price }}
                        <span v-html="oR.currency"></span>
                        {{$t('TO', resLoc)}} {{ oR.maxPrice }}
                    </span>
                    <span v-else class="m-2">
                        <span v-if="oR.forAll">
                            <h5>{{$t('PRICE', resLoc)}}:</h5>
                            <span v-if="oR.price">{{ oR.price }}</span>
                            <span v-else>{{ oR.maxPrice }}</span>
                        </span>
                        <span v-else>
                            <h5>{{$t('PRICE_F', resLoc)}}:</h5>
                            <span v-if="oR.price">{{ oR.price }}</span>
                            <span v-else>{{ oR.maxPrice }}</span>
                        </span>
                    </span>
                    <span v-html="oR.currency"></span>
                    <span v-if="oR.forAll"> {{$t('PRICE_A',resLoc)}}</span>
                    <span v-else> {{$t('PRICE_I',resLoc)}}</span>
                </b-col>
                <b-col v-else></b-col>
            </b-row>


        </b-container>
    </div>
</template>

<script>
import { BContainer, BRow, BCol, BLink } from 'bootstrap-vue';
import {SubjTypes} from '@/plugins/SubjTypes.js';
import {WayTypes} from '@/plugins/WayTypes.js';

export default {
  name: 'User',
  components: {
    BContainer, BRow, BCol, BLink
  },
  data: function() {
    return {
      userNameL: '',
      outingNameL: '',
      userNameR: '',
      outingNameR: '',
      resLoc: '',
      outingWayTypeL: '',
      outingWayTypeR: '',
      outingSubjTypeL: '',
      outingSubjTypeR: '',
      individL: '',
      unaidedL: '',
      individR: '',
      unaidedR: '',
      toBarL: '',
      toBarR: '',
      fromBarL: '',
      fromBarR: '',
      outingUrlL: '',
      outingUrlR: '',
      oL: {},
      oR: {},
      cmp: {}
    }
  },
  mounted() {
    //this.userName = this.$rmEncHyp(this.$route.query.userName);
    this.userNameL = this.$rmEncHyp(this.$route.params.userNameL);
    this.outingNameL = this.$rmEncHyp(this.$route.params.outingNameL);
    this.userNameR = this.$rmEncHyp(this.$route.params.userNameR);
    this.outingNameR = this.$rmEncHyp(this.$route.params.outingNameR);
    this.compare();
  },
  methods: {
    async compare() {
      try {
            const response = await this.$http.get('/compare', {
                params: {
                    userNameL: this.userNameL,
                    outingNameL: this.outingNameL,
                    userNameR: this.userNameR,
                    outingNameR: this.outingNameR,
                }
            });
            this.render(response.data);
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('Compare: /compare '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },

    render(cmp) {
        this.resLoc = cmp.ol.intLoc;
        this.cmp = cmp;
        this.oL = cmp.ol;
        this.oR = cmp.or;
        this.outingUrlL = '/Outing/'+this.$addEncHyp(this.oL.outingName)+'/'+this.$addEncHyp(this.oL.userName);
        this.outingUrlR = '/Outing/'+this.$addEncHyp(this.oR.outingName)+'/'+this.$addEncHyp(this.oR.userName);

        for(let i = 0; i < cmp.ol.toCountries.length; i++) {
            let ind = true;
            for(let i1 = 0; i1 < cmp.or.toCountries.length; i1++) {
                if(cmp.ol.toCountries[i] === cmp.or.toCountries[i1]) {
                    ind = false;
                    break;
                }
            }
            if(ind) this.toBarL = this.toBarL + (i==0 ? '' : '<br>') + '<span class="green">'+cmp.ol.toCountries[i]+'</span>';
            else this.toBarL = this.toBarL + (i==0 ? '' : '<br>') + cmp.ol.toCountries[i];

            for(let j = 0; j < cmp.ol.toDistricts.length; j++) {
                if(cmp.ol.toDistricts[j].countryName === cmp.ol.toCountries[i]) {
                    ind = true;
                    for(let j1 = 0; j1 < cmp.or.toDistricts.length; j1++) {
                        if(cmp.ol.toDistricts[j].districtName === cmp.or.toDistricts[j1].districtName) {
                            ind = false;
                            break;
                        }
                    }
                    if(ind) this.toBarL = this.toBarL + '<br> - <span class="green">'+cmp.ol.toDistricts[j].districtName+'</span>';
                    else this.toBarL = this.toBarL+'<br> - '+ cmp.ol.toDistricts[j].districtName;

                    for(let k = 0; k < cmp.ol.toCities.length; k++) {
                        if(cmp.ol.toCities[k].districtName === cmp.ol.toDistricts[j].districtName) {
                            ind = true;
                            for(let k1 = 0; k1 < cmp.or.toCities.length; k1++) {
                                if(cmp.ol.toCities[k].cityName === cmp.or.toCities[k1].cityName) {
                                    ind = false;
                                    break;
                                }
                            }
                            if(ind) this.toBarL = this.toBarL + '<br>&nbsp;&nbsp;&nbsp;* <span class="green">'+cmp.ol.toCities[k].cityName+'</span>';
                            else this.toBarL = this.toBarL + '<br>&nbsp;&nbsp;&nbsp;* ' + cmp.ol.toCities[k].cityName;
                            if(cmp.ol.toEnsembles.length || cmp.ol.toPureSights.length) this.toBarL = this.toBarL + ': ';

                            // i - country
                            // j- district
                            // k- city
                            // l - ensemble
                            // m - sight in ensemble
                            // n - pure sight (in city)

                            let first = true;
                            //let hasEnsemble = false;
                            for(let l = 0; l < cmp.ol.toEnsembles.length; l++) {
                                if(cmp.ol.toEnsembles[l].cityName === cmp.ol.toCities[k].cityName) {
                                    //hasEnsemble = true;
                                    ind = true;
                                    for(let l1 = 0; l1 < cmp.or.toEnsembles.length; l1++) {
                                        if(cmp.ol.toEnsembles[l].ensembleName === cmp.or.toEnsembles[l1].ensembleName) {
                                            ind = false;
                                            break;
                                        }
                                    }
                                    for(let l1 = 0; l1 < cmp.or.toPureSights.length; l1++) {
                                        if(cmp.ol.toEnsembles[l].ensembleName === cmp.or.toPureSights[l1].sightName &&
                                            cmp.ol.toEnsembles[l].cityName === cmp.or.toPureSights[l1].cityName) {
                                            ind = false;
                                            break;
                                        }
                                    }
                                    if(ind) {
                                        //hasEnsemble = true;
                                        this.toBarL = this.toBarL + '<span class="green">'+cmp.ol.toEnsembles[l].ensembleName+'</span> ';
                                    } else {
                                        this.toBarL = this.toBarL + cmp.ol.toEnsembles[l].ensembleName + ' ';
                                        //hasEnsemble = true;
                                    }
                                    first=true;
                                    let hasSights = false;
                                    for(let m = 0; m < cmp.ol.toSightsInEnsemble.length; m++) {
                                        if(cmp.ol.toSightsInEnsemble[m].ensembleName && cmp.ol.toSightsInEnsemble[m].ensembleName === cmp.ol.toEnsembles[l].ensembleName) {
                                            if(first) this.toBarL = this.toBarL + '(';
                                            ind = true;
                                            hasSights = true;
                                            for(let m1 = 0; m1 < cmp.or.toSightsInEnsemble.length; m1++) {
                                                if(cmp.ol.toSightsInEnsemble[m].sightName === cmp.or.toSightsInEnsemble[m1].sightName) {
                                                    ind = false;
                                                    break;
                                                }
                                            }
                                            if(ind) {
                                                if(!first) this.toBarL = this.toBarL + ', <span class="green">'+cmp.ol.toSightsInEnsemble[m].sightName+'</span>';
                                                else this.toBarL = this.toBarL + '<span class="green">'+cmp.ol.toSightsInEnsemble[m].sightName+'</span>';
                                            } else {
                                                if(!first) this.toBarL = this.toBarL +  ', ' + cmp.ol.toSightsInEnsemble[m].sightName;
                                                else this.toBarL = this.toBarL + cmp.ol.toSightsInEnsemble[m].sightName;
                                        }
                                            first = false;
                                        } // if SightInEnsemble
                                            if(hasSights && m==cmp.ol.toSightsInEnsemble.length-1) this.toBarL = this.toBarL + '), ';
                                    } // for m
                                } // if Ensemble
                            }

                            first=true;
                            for(let n = 0; n < cmp.ol.toPureSights.length; n++) {
                                if(cmp.ol.toPureSights[n].cityName === cmp.ol.toCities[k].cityName) {
                                    ind = true;
                                    for(let n1 = 0; n1 < cmp.or.toPureSights.length; n1++) {
                                        if(cmp.ol.toPureSights[n].sightName === cmp.or.toPureSights[n1].sightName) {
                                            ind = false;
                                            break;
                                        }
                                    }
                                    if(ind) {
                                        for(let n1 = 0; n1 < cmp.or.toEnsembles.length; n1++) {
                                            if(cmp.ol.toPureSights[n].sightName === cmp.or.toEnsembles[n1].ensembleName
                                                && cmp.ol.toPureSights[n].cityName === cmp.or.toEnsembles[n1].cityName) {
                                                    ind = false;
                                                    break;
                                            }
                                        }
                                    }
                                    let sgn = (this.toBarL.charAt(this.toBarR.length-1)==',' || first) ? ' ' : ', ';
                                    if(ind) {
                                        this.toBarL = this.toBarL + sgn + '<span class="green">'+cmp.ol.toPureSights[n].sightName+'</span> ';
                                    } else {
                                        this.toBarL = this.toBarL + sgn + cmp.ol.toPureSights[n].sightName;
                                    }
                                    first = false;
                                } // if Sight

                            } // for l
                        } // if City
                    } // for k
                } // if District
            } // for j
        } // for i

        for(let i = 0; i < cmp.or.toCountries.length; i++) {
            let ind = true;
            for(let i1 = 0; i1 < cmp.ol.toCountries.length; i1++) {
                if(cmp.or.toCountries[i] === cmp.ol.toCountries[i1]) {
                    ind = false;
                    break;
                }
            }
            if(ind) this.toBarR = this.toBarR + (i==0 ? '' : '<br>') + '<span class="green">'+cmp.or.toCountries[i]+'</span>';
            else this.toBarR = this.toBarR + (i==0 ? '' : '<br>') + cmp.or.toCountries[i];

            for(let j = 0; j < cmp.or.toDistricts.length; j++) {
                if(cmp.or.toDistricts[j].countryName === cmp.or.toCountries[i]) {
                    ind = true;
                    for(let j1 = 0; j1 < cmp.ol.toDistricts.length; j1++) {
                        if(cmp.or.toDistricts[j].districtName === cmp.ol.toDistricts[j1].districtName) {
                            ind = false;
                            break;
                        }
                    }
                    if(ind) this.toBarR = this.toBarR + '<br> - <span class="green">'+cmp.or.toDistricts[j].districtName+'</span>';
                    else this.toBarR = this.toBarR+'<br> - '+ cmp.or.toDistricts[j].districtName;

                    for(let k = 0; k < cmp.or.toCities.length; k++) {
                        if(cmp.or.toCities[k].districtName === cmp.or.toDistricts[j].districtName) {
                            ind = true;
                            for(let k1 = 0; k1 < cmp.ol.toCities.length; k1++) {
                                if(cmp.or.toCities[k].cityName === cmp.ol.toCities[k1].cityName) {
                                    ind = false;
                                    break;
                                }
                            }
                            if(ind) this.toBarR = this.toBarR + '<br>&nbsp;&nbsp;&nbsp;* <span class="green">'+cmp.or.toCities[k].cityName+'</span>';
                            else this.toBarR = this.toBarR + '<br>&nbsp;&nbsp;&nbsp;* ' + cmp.or.toCities[k].cityName;
                            //if(cmp.or.toEnsembles.length || cmp.or.toPureSights.length) this.toBarR = this.toBarR + ': ';
                            if(this.cityHasEnsembles(cmp.or.toCities[k].cityName, cmp.or.toEnsembles) ||
                               this.cityHasPureSights(cmp.or.toCities[k].cityName, cmp.or.toPureSights)) this.toBarR = this.toBarR + ': ';

                            // i - country
                            // j- district
                            // k- city
                            // l - ensemble
                            // m - sight in ensemble
                            // n - pure sight (in city)

                            let first = true;
                            //let hasEnsemble = false;
                            for(let l = 0; l < cmp.or.toEnsembles.length; l++) {
                                if(cmp.or.toEnsembles[l].cityName === cmp.or.toCities[k].cityName) {
                                    ind = true;
                                    //hasEnsemble = true;
                                    for(let l1 = 0; l1 < cmp.ol.toEnsembles.length; l1++) {
                                        if(cmp.or.toEnsembles[l].ensembleName === cmp.ol.toEnsembles[l1].ensembleName) {
                                            ind = false;
                                            break;
                                        }
                                    }
                                    for(let l1 = 0; l1 < cmp.ol.toPureSights.length; l1++) {
                                        if(cmp.or.toEnsembles[l].ensembleName === cmp.ol.toPureSights[l1].sightName &&
                                            cmp.or.toEnsembles[l].cityName === cmp.ol.toPureSights[l1].cityName) {
                                            ind = false;
                                            break;
                                        }
                                    }
                                    if(ind) this.toBarR = this.toBarR + '<span class="green">'+cmp.or.toEnsembles[l].ensembleName+'</span> ';
                                    else this.toBarR = this.toBarR + cmp.or.toEnsembles[l].ensembleName + ' ';
                                    first=true;
                                    let hasSights = false;
                                    for(let m = 0; m < cmp.or.toSightsInEnsemble.length; m++) {
                                        if(cmp.or.toSightsInEnsemble[m].ensembleName && cmp.or.toSightsInEnsemble[m].ensembleName === cmp.or.toEnsembles[l].ensembleName) {
                                            hasSights = true;
                                            if(first) this.toBarR = this.toBarR + '(';
                                            ind = true;
                                            for(let m1 = 0; m1 < cmp.ol.toSightsInEnsemble.length; m1++) {
                                                if(cmp.or.toSightsInEnsemble[m].sightName === cmp.ol.toSightsInEnsemble[m1].sightName) {
                                                    ind = false;
                                                    break;
                                                }
                                            }
                                            if(ind) {
                                                if(!first) this.toBarR = this.toBarR + ', <span class="green">'+cmp.or.toSightsInEnsemble[m].sightName+'</span>';
                                                else this.toBarR = this.toBarR + '<span class="green">'+cmp.or.toSightsInEnsemble[m].sightName+'</span>';
                                            } else {
                                                if(!first) this.toBarR = this.toBarR +  ', ' + cmp.or.toSightsInEnsemble[m].sightName;
                                                else this.toBarR = this.toBarR + cmp.or.toSightsInEnsemble[m].sightName;
                                            }
                                            first = false;
                                        } // if SightInEnsemble
                                            if(hasSights && m==cmp.or.toSightsInEnsemble.length-1) this.toBarR = this.toBarR + '), ';
                                    } // for m
                                } // if Ensemble
                            }

                            first=true;
                            for(let n = 0; n < cmp.or.toPureSights.length; n++) {
                                if(cmp.or.toPureSights[n].cityName === cmp.or.toCities[k].cityName) {
                                    ind = true;
                                    for(let n1 = 0; n1 < cmp.ol.toPureSights.length; n1++) {
                                        if(cmp.or.toPureSights[n].sightName === cmp.ol.toPureSights[n1].sightName) {
                                            ind = false;
                                            break;
                                        }
                                    }
                                    if(ind) {
                                        for(let n1 = 0; n1 < cmp.ol.toEnsembles.length; n1++) {
                                            if(cmp.or.toPureSights[n].sightName === cmp.ol.toEnsembles[n1].ensembleName
                                                && cmp.or.toPureSights[n].cityName === cmp.ol.toEnsembles[n1].cityName) {
                                                    ind = false;
                                                    break;
                                                }

                                        }
                                    }
                                    let sgn = (this.toBarR.charAt(this.toBarR.length-1)==',' || first) ? ' ' : ', ';

                                    if(ind) {
                                        this.toBarR = this.toBarR + sgn + '<span class="green">'+cmp.or.toPureSights[n].sightName+'</span> ';

                                    }
                                    else {
                                        this.toBarR = this.toBarR + sgn + cmp.or.toPureSights[n].sightName;
                                    }
                                    first = false;
                                } // if Sight

                            } // for l
                        } // if City
                    } // for k
                } // if District
            } // for j
        } // for i


        for(let i = 0; i < cmp.ol.fromCountries.length; i++) {
            let ind = true;
            for(let i1 = 0; i1 < cmp.or.fromCountries.length; i1++) {
                if(cmp.ol.fromCountries[i] === cmp.or.fromCountries[i1]) {
                    this.fromBarL = this.fromBarL + (i==0 ? '' : '<br>') + cmp.ol.fromCountries[i];
                    ind = false;
                    break;
                }
            }
            if(ind) this.fromBarL = this.fromBarL + (i==0 ? '' : '<br>') + '<span class="green">'+cmp.ol.fromCountries[i]+'</span>';
            for(let j = 0; j < cmp.ol.fromDistricts.length; j++) {
                if(cmp.ol.fromDistricts[j].countryName === cmp.ol.fromCountries[i]) {
                    ind = true;
                    for(let j1 = 0; j1 < cmp.or.fromDistricts.length; j1++) {
                        if(cmp.ol.fromDistricts[j].districtName === cmp.or.fromDistricts[j1].districtName) {
                            this.fromBarL = this.fromBarL+'<br> - '+ cmp.ol.fromDistricts[j].districtName;
                            ind = false;
                            break;
                        }
                    }
                    if(ind) this.fromBarL = this.fromBarL + '<br> - <span class="green">'+cmp.ol.fromDistricts[j].districtName+'</span>';
                    for(let k = 0; k < cmp.ol.fromCities.length; k++) {
                        if(cmp.ol.fromCities[k].districtName === cmp.ol.fromDistricts[j].districtName) {
                            ind = true;
                            for(let k1 = 0; k1 < cmp.or.fromCities.length; k1++) {
                                if(cmp.ol.fromCities[k].cityName === cmp.or.fromCities[k1].cityName) {
                                    this.fromBarL = this.fromBarL + '<br>&nbsp;&nbsp;&nbsp;* ' + cmp.ol.fromCities[k].cityName + ' ';
                                    ind = false;
                                    break;
                                }
                            }
                            if(ind) this.fromBarL = this.fromBarL + '<br>&nbsp;&nbsp;&nbsp;* <span class="green">'+cmp.ol.fromCities[k].cityName+'</span> ';
                        } // if City
                    } // for k
                } // if District
            } // for j
        } // for i

        for(let i = 0; i < cmp.or.fromCountries.length; i++) {
            let ind = true;
            for(let i1 = 0; i1 < cmp.ol.fromCountries.length; i1++) {
                if(cmp.or.fromCountries[i] === cmp.ol.fromCountries[i1]) {
                    this.fromBarR = this.fromBarR + (i==0 ? '' : '<br>') + cmp.or.fromCountries[i];
                    ind = false;
                    break;
                }
            }
            if(ind) this.fromBarR = this.fromBarR + (i==0 ? '' : '<br>') + '<span class="green">'+cmp.or.fromCountries[i]+'</span>';
            for(let j = 0; j < cmp.or.fromDistricts.length; j++) {
                if(cmp.or.fromDistricts[j].countryName === cmp.or.fromCountries[i]) {
                    ind = true;
                    for(let j1 = 0; j1 < cmp.ol.fromDistricts.length; j1++) {
                        if(cmp.or.fromDistricts[j].districtName === cmp.ol.fromDistricts[j1].districtName) {
                            this.fromBarR = this.fromBarR+'<br> - '+ cmp.or.fromDistricts[j].districtName;
                            ind = false;
                            break;
                        }
                    }
                    if(ind) this.fromBarR = this.fromBarR + '<br> - <span class="green">'+cmp.or.fromDistricts[j].districtName+'</span>';
                    for(let k = 0; k < cmp.or.fromCities.length; k++) {
                        if(cmp.or.fromCities[k].districtName === cmp.or.fromDistricts[j].districtName) {
                            ind = true;
                            for(let k1 = 0; k1 < cmp.ol.fromCities.length; k1++) {
                                if(cmp.or.fromCities[k].cityName === cmp.ol.fromCities[k1].cityName) {
                                    this.fromBarR = this.fromBarR + '<br>&nbsp;&nbsp;&nbsp;* ' + cmp.or.fromCities[k].cityName + ' ';
                                    ind = false;
                                    break;
                                }
                            }
                            if(ind) this.fromBarR = this.fromBarR + '<br>&nbsp;&nbsp;&nbsp;* <span class="green">'+cmp.or.fromCities[k].cityName+'</span> ';
                        }
                    }
                }
            }
        }

        if(cmp.ol.virtual) this.outingWayTypeL = this.$t('OU_VRT',this.resLoc);
        else {
            //this.outingWayTypeL = cmp.ol.foot ? this.$t('OU_FOOT',this.resLoc) + ", " : "";
            for(let i = 0; i < WayTypes.length; i++) this.outingWayTypeL = this.outingWayTypeL + this.cmpPropertyL(WayTypes[i]);
            if(this.outingWayTypeL.endsWith(', ')) this.outingWayTypeL = this.outingWayTypeL.substring(0,this.outingWayTypeL.length-2);
        }

        //this.outingSubjTypeL = cmp.ol.intro ? this.$t('C_INTRO',this.resLoc) + ", " : "";
        for(let i = 0; i < SubjTypes.length; i++) this.outingSubjTypeL = this.outingSubjTypeL + this.cmpPropertyL(SubjTypes[i]);
        if(this.outingSubjTypeL.endsWith(', ')) this.outingSubjTypeL = this.outingSubjTypeL.substring(0,this.outingSubjTypeL.length-2);
        this.individL = cmp.ol.individ ?
            ( cmp.or.individ ?  this.$t('C_INDIVID',this.resLoc) : '<span class="green">'+this.$t('C_INDIVID',this.resLoc)+'</span>' ) :
            "";
        this.unaidedL = cmp.ol.unaided ?
            ( cmp.or.unaided ?  this.$t('C_UNAID',this.resLoc) : '<span class="green">'+this.$t('C_UNAID',this.resLoc)+'</span>' ) :
            "";

        if(cmp.or.virtual) this.outingWayTypeR = this.$t('OU_VRT',this.resLoc);
        else {
            //this.outingWayTypeR = cmp.or.foot ? this.$t('OU_FOOT',this.resLoc) + ", " : "";
            for(let i = 0; i < WayTypes.length; i++) {
                this.outingWayTypeR = this.outingWayTypeR + this.cmpPropertyR(WayTypes[i]);
            }
            if(this.outingWayTypeR.endsWith(', ')) this.outingWayTypeR = this.outingWayTypeR.substring(0,this.outingWayTypeR.length-2);
        }
        //this.outingSubjTypeR = cmp.or.intro ? this.$t('C_INTRO',this.resLoc) + ", " : "";
        for(let i = 0; i < SubjTypes.length; i++) this.outingSubjTypeR = this.outingSubjTypeR + this.cmpPropertyR(SubjTypes[i]);
        if(this.outingSubjTypeR.endsWith(', ')) this.outingSubjTypeR = this.outingSubjTypeR.substring(0,this.outingSubjTypeR.length-2);
        this.individR = cmp.or.individ ?
            ( cmp.ol.individ ?  this.$t('C_INDIVID',this.resLoc) : '<span class="green">'+this.$t('C_INDIVID',this.resLoc)+'</span>' ) :
            "";
        this.unaidedR = cmp.or.unaided ?
            ( cmp.ol.unaided ?  this.$t('C_UNAID',this.resLoc) : '<span class="green">'+this.$t('C_UNAID',this.resLoc)+'</span>' ) :
            "";
    },
    cmpPropertyL(sType) {
        if(this.cmp.ol[sType[0]]) {
            if(this.cmp.or[sType[0]])  return this.$t(sType[1],this.resLoc)+', ';
            else return '<span class="green">'+this.$t(sType[1],this.resLoc)+'</span>, ';
        }
        return "";
    },
    cmpPropertyR(sType) {
        if(this.cmp.or[sType[0]]) {
            if(this.cmp.ol[sType[0]]) return this.$t(sType[1],this.resLoc)+', ';
            else return '<span class="green">'+this.$t(sType[1],this.resLoc)+'</span>, ';
        }
        return "";
    },
    toLOuName() {
        this.$router.push({ path: '/Outing/'+this.$addEncHyp(this.cmp.ol.outingName)+'/'+this.$addEncHyp(this.cmp.ol.userName) });
    },
    toROuName() {
        this.$router.push({ path: '/Outing/'+this.$addEncHyp(this.cmp.or.outingName)+'/'+this.$addEncHyp(this.cmp.or.userName) });
    },
    cityHasEnsembles(cityName, ensembles) {
        //console.log('ensembles', cityName, ensembles.length);
        for(let i=0; i<ensembles.length; i++)
            if(ensembles[i].cityName===cityName) return true
        return false;
    },
    cityHasPureSights(cityName, sights) {
        //console.log('sights', cityName, sights.length);
        for(let i=0; i<sights.length; i++)
            if(sights[i].cityName===cityName) return true
        return false;
    }
  }
}

</script>

<style>
.green {
    color:#065c05;
}


</style>